import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { SearchBarService } from 'src/app/shared/components/search-bar/search-bar.service';
import { SiteTypeEnum } from 'src/app/shared/enums';

@Component({
  selector: 'app-message-templates',
  templateUrl: './message-templates.component.html',
  styleUrls: ['./message-templates.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageTemplatesComponent implements OnDestroy {
  loading: boolean;
  subscriptions = new Subscription();
  selectedIndex = 0;
  selectedTemplateType = 0;

  readonly channelsTypes = [SiteTypeEnum.WhatsApp, SiteTypeEnum.Kakaotalk];

  constructor(private searchBarService: SearchBarService, private customRouter: CustomRouter) {
    const { type } = customRouter.params;
    if (type) {
      const index = this.channelsTypes.indexOf(type);
      if (index === -1) {
        this.redirectToTabType(0);
      } else {
        this.selectedIndex = index;
        this.selectedTemplateType = index;
      }
    }
  }

  selectedIndexChanged(index: number) {
    if (this.selectedIndex === index) {
      return;
    }
    this.redirectToTabType(index);
  }

  private redirectToTabType(index) {
    this.selectedTemplateType = null;
    setTimeout(() => {
      this.selectedIndex = index;
      this.selectedTemplateType = index;

      this.customRouter.transitionTo(
        'auth.alcmeon.fuse.parameters.message-templates',
        { type: this.channelsTypes[index] },
        {
          reload: false,
          inherit: true,
          notify: false,
        }
      );
    }, 1000);
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
    this.searchBarService.onDidLeave();
  }
}
